module.exports = __webpack_public_path__ + "static/media/illust1.47929fc8.png";